export default __webpack_public_path__ + "static/media/tips_icon.2926198c.png";